import { render, staticRenderFns } from "./TabJilinAccident.vue?vue&type=template&id=38b62513&scoped=true"
import script from "./TabJilinAccident.vue?vue&type=script&lang=js"
export * from "./TabJilinAccident.vue?vue&type=script&lang=js"
import style0 from "./TabJilinAccident.vue?vue&type=style&index=0&id=38b62513&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b62513",
  null
  
)

export default component.exports